export default "__VITE_ASSET__BpxXxgyh__"